import React from "react";
import { skipToken } from "@reduxjs/toolkit/query/react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { Button, Page } from "@sscs/ui";
import { FILESTREAM_PURL } from "Constants";
import { useAppSelector, useReports } from "Hooks";
import { ReportExportButton } from "Modules/download";
import { MoveFileToProject } from "Modules/moveFileToProject";
import { useGetSingleFileQuery } from "Services";
import {
  closeMoveToProject,
  openMoveToProject,
  selectMoveToProjectDialog,
} from "../../store/dialogs.slice";
import styles from "./fileStreamReportHeader.module.scss";
import FileStreamStatusText from "./FileStreamStatusText";

type FileStreamReportHeaderProps = {
  fileId: string;
  canMoveToProject: boolean;
};

function FileStreamReportHeader({
  fileId,
  canMoveToProject,
}: FileStreamReportHeaderProps): React.JSX.Element {
  const dispatch = useDispatch();
  const { groupId } = useParams();
  const moveToProjectDialog = useAppSelector(selectMoveToProjectDialog);

  const { closeAllReports } = useReports();

  const { data: singleFile } = useGetSingleFileQuery(
    !moveToProjectDialog.isOpen ? fileId : skipToken,
  );

  return (
    <Page.ExpandableHeader>
      {singleFile && (
        <MoveFileToProject
          isOpen={moveToProjectDialog.isOpen}
          onClose={(isMoved) => {
            dispatch(closeMoveToProject());
            if (isMoved === true) {
              closeAllReports({
                groupId,
                projectName: FILESTREAM_PURL.projectName,
                packageName: FILESTREAM_PURL.packageName,
                version: singleFile.id,
              });
            }
          }}
          file={singleFile}
          linkToProject={false}
        />
      )}
      <Page.ExpandableHeader.Summary>
        <FileStreamStatusText file={singleFile} />
        <div className={styles.actions}>
          <ReportExportButton
            versionId={fileId}
            isRepro={false}
            fileType="FILESTREAM"
          />
          {canMoveToProject && (
            <Button
              type="button"
              color="primary"
              onClick={() => dispatch(openMoveToProject())}
            >
              Move to project
            </Button>
          )}
        </div>
      </Page.ExpandableHeader.Summary>
    </Page.ExpandableHeader>
  );
}

export default FileStreamReportHeader;
